export default __webpack_public_path__ + "static/media/birthday-reminder.998c979d.svg";